export enum enumEntrySummaryStatusTab {
  ALL,
  DRAFTS,
  PROCESSING,
  RELEASED,
}
